import { Speakable } from '../modules/spkbl.js'

const buttonElement = document.querySelector('button[data-action="speakable"]');

if (buttonElement) {
  const speakable = Speakable.init({
    selector: '#main',
    l18n: {
      play: 'Text vorlesen',
      pause: 'Pause',
      progress: 'Fortschritt',
      stop: 'Schließen'
    }
  });

  if (speakable[0]) {
    window.spkbl = speakable[0];
    const spkbl = speakable[0];
    buttonElement.addEventListener('click', () => {
      console.log(spkbl);
      const { classList } = spkbl.player;
      if (classList.contains('spkbl-player--inactive')) {
        console.log('play');
        spkbl.play();
      } else {
        spkbl.pause();
      }
    });
  }
}

